/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import def from "./assets/default.png";
function Profile() {
  const [fetchedBranchList, setFetchedBranchList] = useState(null);
  const [fetchedClassList, setFetchedClassList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch the branch list from API
  useEffect(() => {
    async function getBranchList() {
      setIsLoading(true);
      const fd = new FormData();
      // const res = await hitApi("teacher/teacherCurl", "getBranchDetails", fd);
      const res = await hitApi("branch/branchCurl", "getBranchDetailsAll", fd);
      if (res.data.success) {
        setIsLoading(false);
        setFetchedBranchList(res.data);
      } else {
        setIsLoading(false);
        setFetchedBranchList(res.data);
      }
    }
    getBranchList();
  }, []);

  useEffect(() => {
    async function getClassList() {
      const fd = new FormData();
      // const res = await hitApi("teacher/teacherCurl", "getClassDetails", fd);
      const res = await hitApi("academic/classCurl", "getClassDetails", fd);
      console.log(res);
    if (res) {
        setFetchedClassList(res);
      } else {
        setFetchedClassList(res);
      }
    }
    getClassList();
  }, []);
  return (
    <div style={{ marginTop: "5.5rem" }}>
      <div className="container">
        {/* Profile Card */}
        <div className="card user-info-card mt-2 mb-3">
          <div className="card-body d-flex align-items-center mb-15">
            <div className="user-profile me-3">
              <img src={def} alt="User Profile" />
            </div>

            <div className="user-info">
              <h5 className="mb-1">{localStorage.getItem("user-name")}</h5>
              <p className="mb-1">{localStorage.getItem("user-phno")}</p>
            </div>
          </div>
        </div>

        {/* Assigned Branch Card */}
        <div className="card mb-3 shadow-sm">
          <div className="card-body">
            <p className="mb-1 fw-bold">Assigned Branch:</p>
            {fetchedBranchList?.length > 0 ? (
              fetchedBranchList?.map((ele, idx) => (
                <h6 className="fw-bold" key={idx}>
                  {ele.name}
                </h6>
              ))
            ) : (
              <div className="text-muted">No branch assigned</div>
            )}
          </div>

          {/* Assigned Class Card */}
          {/* <div className="card-body">
            <p className="mb-1 fw-bold">Assigned Class:</p>
            {fetchedClassList?.length > 0 ? (
              fetchedClassList.map((ele, idx) => (
                <h6 className="fw-bold" key={idx}>
                  {ele.label}
                </h6>
              ))
            ) : (
              <div className="text-muted">No class assigned</div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Profile;
